import React, { Component } from 'react'
import { connect as connectRedux } from 'react-redux'
import get from 'lodash/get'
import split from 'lodash/split'
import size from 'lodash/size'
import isString from 'lodash/isString'
import Button, { TYPES } from '../../../../Button/index'
import { getBoundActions } from '../../../../../actions/index'
import { dispatchWhen } from '../../../../../services/dispatch-when/index'
import { updateSubject, deactivateSubject } from '../../../../../services/testarossa/index'
import { SET_EVENT_PAGE_VIEWED } from '../../../../../services/event-tracking/actions'
import HeroImage from '../../../../HeroImage/index'
import { TESTAROSSA_SPOTLIGHT_CLICKED_GA4_EVENT } from '../../../../../services/event-tracking/index'
import { H1, HEADING_TYPES } from '../../../../Heading/index'

class SpotlightAdV2 extends Component {
  componentDidMount () {
    const { props, sendGaSpotlightEvent } = this
    const { campaign = {}, variation = {}, subject = {} } = props

    const data = get(variation, 'data', {})
    const impressionLimit = get(data, ['config', 'value', 'impressionLimit'], 5)
    const impressions = get(subject, ['variables', 'impressions'], 0)

    let total = impressions + 1
    // there is a bug here with older subjects where the
    // impression variables were "[object object]111111" so we're fixing this...
    if (isString(total)) {
      total = size(split(total, '1'))
    }

    updateSubject({ campaign, variables: { impressions: total } })

    if (total >= impressionLimit) {
      dispatchWhen(SET_EVENT_PAGE_VIEWED, () => {
        deactivateSubject({ campaign })
      })
    } else {
      sendGaSpotlightEvent()
    }
  }

  onClickCTA = () => {
    const { props } = this
    const { campaign = {} } = props
    dispatchWhen(SET_EVENT_PAGE_VIEWED, () => {
      deactivateSubject({ campaign })
    })
  }

  sendGaSpotlightEvent = () => {
    const { setEventDefault } = this.props

    // GA4 event
    setEventDefault(TESTAROSSA_SPOTLIGHT_CLICKED_GA4_EVENT)
  }

  render () {
    const { props } = this
    const { variation = {} } = props
    const { data = {} } = variation
    const image = get(data, ['image', 'value'], '')
    const body = get(data, ['body', 'value'])
    const ctaText = get(data, ['cta', 'label'])
    const ctaUrl = get(data, ['cta', 'value'])
    const ctaTarget = get(data, ['cta', 'target'])
    const label = get(data, ['label', 'value'])
    const title = get(data, ['title', 'value'])

    return (
      <div className="spotlight-ad-v2">
        <HeroImage
          className={['spotlight-ad-v2__background-hero']}
          url={image}
        />
        <div className="spotlight-ad-v2__overlay"/>
        <div className="spotlight-ad-v2__overlay-darken" />
        <div className="spotlight-ad-v2__content">
          {
            label
              ? <div className="spotlight-ad-v2__label-container">
                  <span className="spotlight-ad-v2__label">
                    { label }
                  </span>
                </div>
              : null
          }
          {
            title
              ? <H1
                  as={HEADING_TYPES.H4}
                  inverted
                  className="spotlight-ad-v2__title"
                >
                  {title}
                </H1>
              : null
          }
          {
            body
              ? <p className="spotlight-ad-v2__body">
                  {body}
                </p>
              : null
          }
          {
            ctaText && ctaUrl
              ? <Button
                  type={TYPES.PRIMARY}
                  className="spotlight-ad-v2__cta"
                  onClick={() => {
                    this.sendGaSpotlightEvent(); this.onClickCTA()
                  }}
                  target={ctaTarget === '_blank' ? '_blank' : null}
                  url={ctaUrl}
                >
                  {ctaText}
                </Button>
              : null
          }
        </div>
      </div>
    )
  }
}

export default connectRedux(
  (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      setEventDefault: actions.eventTracking.setEventDefault,
    }
  },
)(SpotlightAdV2)
